import React from 'react'

import classes from './SearchSelectFilter.module.sass'

import { OptionItemInterface } from '../../../types/interfaces'
import { useSearchSelectFilter } from './hooks/useSearchSelectFilter'
import { useSelector } from 'react-redux'
import { selectDarkTheme } from '../../../../store/slices/settingsSlice'

type Props = {
  label?: string
  options: OptionItemInterface[]
  value: string
  onChangeHandler: (value: string) => void
  placeholder: string
  emptyPlaceHolder: string
  keySelectField?: string
  disabled?: boolean
  visibleOptionsLength?: number
}

export const SearchSelectFilter = ({
  label,
  options,
  value,
  onChangeHandler,
  disabled,
  placeholder,
  emptyPlaceHolder,
  visibleOptionsLength = 5,
}: Props) => {
  const {
    filteredList,
    searchString,
    setSearchString,
    expanded,
    setExpanded,
    createDivRef,
    setFocusedIndex,
    handleKeyDown,
    onBlurAction,
    divRef,
  } = useSearchSelectFilter(options, onChangeHandler, value)

  const dark = useSelector(selectDarkTheme)

  return (
    <div className={classes.SelectContainer}>
      {label && <label className={classes.Label}>{label}</label>}
      <input
        //@ts-ignore
        ref={divRef}
        onKeyDown={(e) => {
          handleKeyDown(0, e)
        }}
        onBlur={onBlurAction}
        tabIndex={-1}
        //@ts-ignore
        // ref={createDivRef(0)}
        disabled={disabled}
        value={value ? filteredList.find((el) => el.value === value)?.label : searchString}
        type="text"
        placeholder={divRef.current && divRef.current.contains(document.activeElement) ?  emptyPlaceHolder : placeholder}
        onFocus={() => {
          setSearchString('')
        }}
        className={dark ? classes.ContainerDark : classes.Container}
        onChange={(e) => {
          setSearchString(e.target.value)
        }}
        onClick={() => {
          setFocusedIndex(0)
          onChangeHandler('')
          if (!expanded) setExpanded((prev) => !prev)
        }}
      />

      {expanded && filteredList.length > 0 && (
        <div className={classes.OptionsContainerAnchor}>
          <div className={classes.OptionsContainer} onClick={(e) => e.stopPropagation()}>
            {filteredList.slice(0, visibleOptionsLength).map((el, index) => (
              <div
                className={dark ? classes.OptionDark : classes.Option}
                tabIndex={-1}
                ref={createDivRef(index + 1)}
                onClick={() => {
                  el.value && setSearchString(el.label)
                  el.value && onChangeHandler(el.value)
                  setExpanded(false)
                }}
                key={el.id}
                hidden={el.hidden}
                defaultValue={el.value}
                onKeyDown={(e) => {
                  handleKeyDown(index, e)
                }}
              >
                {el.label}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
